// index.tsx
// ====================================================================
// ▶ 앱 엔트리포인트 (앱이 부팅될 때 단 한 번 실행되는 영역)
// - 외부 SDK / 서비스(Firebase, Elastic APM 등) 초기화
// - 전역 스타일 / 폰트 로딩
// - React 앱의 root DOM 노드 마운트
// ====================================================================

// 앱 초기화 (React 렌더링 전에 실행)
// 초기화 코드는 여기에 추가해 주세요

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
